import { Component } from '@angular/core';

@Component({
  selector: 'claims-athome-myaccount-electrical-safety',
  templateUrl: './electrical-safety.component.html',
  styleUrls: ['./electrical-safety.component.scss'],
})
export class ManageMyRepairElectricalSafetyComponent {
  open = false;
}
